import { useEffect, useRef } from 'react'
import { pathMatchesTourTemplate } from './tourGuideUtils'
import { hasSeenTour } from './tourPersistence'

export interface WelcomeTourAutoStartOptions {
  activeWorkspaceId: string | null
  isWorkspaceLoading: boolean
  isMobile: boolean
  currentPath: string
  hasOnboardingGate: boolean
  hasOpenModal: boolean
  userId: string | null
  startTour?: (id: string) => boolean
}

export const useWelcomeTourAutoStart = ({
  activeWorkspaceId,
  isWorkspaceLoading,
  isMobile,
  currentPath,
  hasOnboardingGate,
  hasOpenModal,
  userId,
  startTour,
}: WelcomeTourAutoStartOptions): void => {
  const autoStartedRef = useRef(false)

  useEffect(() => {
    if (autoStartedRef.current) return
    if (!activeWorkspaceId || isWorkspaceLoading) return
    if (isMobile) return
    if (!pathMatchesTourTemplate(currentPath, '/workspace/:slug/d')) return
    if (hasOnboardingGate || hasOpenModal) return
    if (userId && hasSeenTour('welcome', userId, activeWorkspaceId, 'user')) {
      autoStartedRef.current = true
      return
    }
    if (!startTour) return

    autoStartedRef.current = true
    startTour('welcome')
  }, [
    activeWorkspaceId,
    currentPath,
    hasOnboardingGate,
    hasOpenModal,
    isMobile,
    isWorkspaceLoading,
    startTour,
    userId,
  ])
}
